<app-header></app-header>
<div class="row w-100 mx-0 auth-page">
  <div class="col-md-4 col-xl-4 mx-auto">
    <login-quote></login-quote>
  </div>
  <div class="col-md-4 col-xl-4 mx-auto">
    <div class="card">
      <div class="row full-height">
        <div>
          <div class="forgot-password-form-wrapper px-4 py-5">
            <div class="py-5">
              <h5 class="login-title">{{ 'AUTH.RESET_PASSWORD_TITLE' | translate }}</h5>
            </div>
            <form class="forms-sample" [formGroup]="forgotPasswordForm" [markRequired]="forgotPasswordForm">
              <div class="form-group">
                <label for="exampleInputEmail1">{{ 'AUTH.EMAIL' | translate | titlecase}}</label>
                <input type="email"
                       class="form-control"
                       id="exampleInputEmail1"
                       formControlName="email"
                       placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'AUTH.EMAIL' | translate }}">
              </div>
              <div class="mt-3">
                <button type="submit"
                  [disabled]="!forgotPasswordForm.valid"
                  (click)="resetPassword()"
                  class="btn btn-primary ml-2 mb-2 mb-md-0">
                  {{ 'AUTH.RESET_PASSWORD' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
